export const ExportGroup = {
    Contracted: 1,
    Insurances: 2,
    KaratUsersAndOu: 4,
    KaratContracted: 8,
    Cafeterie: 16,
    JapTables: 32,
    ApiUsage: 64,
    Offers: 128,

    ListContracts: 127, // Contracted | Insurances | KaratUsersAndOu | KaratContracted | Cafeterie | JapTables | ApiUsage
    ListOffers: 128,    // Offers

    All: 255            // Contracted | Insurances | KaratUsersAndOu | KaratContracted | Cafeterie | JapTables | ApiUsage | Offers
} as const;

export type ExportGroup = typeof ExportGroup[keyof typeof ExportGroup];